import { useEffect, useRef } from 'react';

const IDLE_TIMEOUT = 2 * 60 * 60 * 1000; // 2 hours
const CHECK_INTERVAL = 5 * 60 * 1000; // check every 5 minutes

/**
 * Auto-refreshes the page after 2 hours of user inactivity.
 * Skips refresh if a dialog/modal is open (unsaved work protection).
 */
export default function useIdleRefresh() {
  const lastActivity = useRef(Date.now());

  useEffect(() => {
    const updateActivity = () => {
      lastActivity.current = Date.now();
    };

    const events = ['mousedown', 'keydown', 'touchstart', 'scroll'];
    events.forEach(e => window.addEventListener(e, updateActivity, { passive: true }));

    const interval = setInterval(() => {
      const idle = Date.now() - lastActivity.current;
      if (idle < IDLE_TIMEOUT) return;

      // Don't refresh if a dialog/modal is open
      if (document.querySelector('.MuiDialog-root, .MuiModal-root, .MuiDrawer-root')) return;

      window.location.reload();
    }, CHECK_INTERVAL);

    return () => {
      events.forEach(e => window.removeEventListener(e, updateActivity));
      clearInterval(interval);
    };
  }, []);
}
